import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=6651743e&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=6651743e&prod&scoped=true&lang=css&"
import style1 from "./Details.vue?vue&type=style&index=1&id=6651743e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651743e",
  null
  
)

export default component.exports